module.exports = __webpack_public_path__ + "img/2e1635599e14745926f1cfafc3739c70.png";